
const hostname = window.location.hostname.toLowerCase();

let serverUrl = 'https://install.orax.cz/server/apps/orax';
let photogalleryUrl = 'https://install.orax.cz/photogallery';
let imagesUrl = 'https://install.orax.cz/images';
let sourceRoot = 'https://install.orax.cz';

export const environment = {
  production: true,
	projectGroup: 'standard',
	appTitle: 'ORAX administrace',
	sourceRoot,
	cookiePrefix: 'orax5_',
	serverUrl,
	photogalleryUrl,
	adsUrl: '/images/ads',
	imagesUrl,
	showRecordsId: false,
	showDevelopmentFields: false,
	showDisabledModules: false,
	pcHashName: ''

};
